'use client';

import React__default from 'react';

function CheckSuccessIcon() {
    return (React__default.createElement("svg", { width: '15', height: '15', viewBox: '0 0 15 15', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', xmlnsXlink: 'http://www.w3.org/1999/xlink' },
        React__default.createElement("g", { id: 'MY-JOBS', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd', strokeLinecap: 'round', strokeLinejoin: 'round' },
            React__default.createElement("g", { id: 'CC/MYJOBS-SAVED-APPLYMULTIPLE-CHOOSEFILE', transform: 'translate(-1003.000000, -365.000000)', stroke: '#45C500', strokeWidth: '1.6' },
                React__default.createElement("g", { id: 'Group-25', transform: 'translate(190.000000, 267.000000)' },
                    React__default.createElement("g", { id: 'Group-26', transform: 'translate(562.344262, 0.000000)' },
                        React__default.createElement("g", { id: 'Group-22', transform: 'translate(0.000000, 62.000000)' },
                            React__default.createElement("g", { id: 'Group-11', transform: 'translate(244.000000, 28.000000)' },
                                React__default.createElement("g", { transform: 'translate(2.000000, 2.000000)', id: 'Group-27' },
                                    React__default.createElement("g", { id: 'icons8-checkmark-(5)', transform: 'translate(6.000000, 7.000000)' },
                                        React__default.createElement("polyline", { id: 'Path', points: '0 6.07896794 4.91329412 10 12 0' })))))))))));
}

export { CheckSuccessIcon as default };
//# sourceMappingURL=index.js.map
